export const generateDataTableId = (operatorId: string, page: string) => {
  return `${operatorId}:${page}-table`;
};
